import React, { useState } from 'react';
import { Alert, Button, Card, Container, Form } from 'react-bootstrap';
import { postRequest } from '../utils/axiosRequests';

function PatientSerial() {
  const [token, setToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (token.length !== 8 || !/^\d{8}$/.test(token)) {
      setError('Please enter a valid 8-digit token.');
      return;
    }
    setIsLoading(true);
    setError('');
    postRequest('live-announces/validate-serial-token', { token })
      .then((data) => {
        if (data.valid && data.link) {
          window.location.href = data.link;
        } else {
          setError('Invalid or expired token. Please check the token and try again.');
        }
      })
      .catch(() => {
        setError('Invalid or expired token. Please check the token and try again.');
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f0f7fc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <Card style={{ width: '100%', maxWidth: '420px', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,.1)' }}>
        <Card.Header
          style={{
            background: '#228093',
            color: '#fff',
            borderRadius: '16px 16px 0 0',
            padding: '20px 24px',
            fontSize: '1.1rem',
            fontWeight: 700,
          }}
        >
          Appointment Access
        </Card.Header>
        <Card.Body style={{ padding: '32px 24px' }}>
          <p className="text-muted mb-4">
            Enter the 8-digit access token provided by the clinic staff to view today's appointments.
          </p>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Access Token</Form.Label>
              <Form.Control
                type="text"
                inputMode="numeric"
                pattern="\d*"
                maxLength={8}
                value={token}
                onChange={(e) => setToken(e.target.value.replace(/\D/g, ''))}
                placeholder="00000000"
                style={{
                  letterSpacing: '6px',
                  textAlign: 'center',
                  fontSize: '2rem',
                  fontWeight: 700,
                  padding: '12px',
                  borderRadius: '10px',
                }}
                autoFocus
              />
            </Form.Group>
            <Button
              type="submit"
              variant="primary"
              className="w-100"
              style={{ borderRadius: '10px', padding: '12px', fontWeight: 600 }}
              disabled={isLoading || token.length !== 8}
            >
              {isLoading ? 'Validating...' : 'Access Appointments'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PatientSerial;
